export default __webpack_public_path__ + "static/Parcheesi-Cash-12e0dbe931e65112257163e15d85e4a0.webp";